
import Env from '../base/env.js';
import Channels from '../base/channels.js';
import lozad from 'lozad'
import Launcher from '../view/launcher'
import MainnavTouch from '../ui/MainnavTouch'
import UISwitcher from '../ui/UISwitcher'
import gsap from 'gsap'

class UI
{
    constructor()
    {
      if(typeof history.scrollRestoration != 'undefined') {
          history.scrollRestoration = 'manual';
      }
      this.launcher = new Launcher()
      this.uiSwitch =  new UISwitcher()
      Env.framework.mainnav = new MainnavTouch()
      this.detectAppHeight()
      this.resetEnv();
    }

    appHeight()
    {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }

    detectAppHeight()
    {
      this.appHeight()
      Channels.on('window::smartresize',this.appHeight)
    }

    fxIntro(view)
    {
      if(Env.isVisiting === true) {
        const tl = gsap.timeline()
        tl.add([
          gsap.fromTo(view , {  top: 24 },{ top:0, ease:'cubic.out' , duration:1 }),
        ])
      }
    }

    lazy()
    {
      const observer = lozad(); // lazy loads elements with default selector as '.lozad'
      observer.observe();
    }



    resetEnv()
    {
      Channels.on('statechange::before',function()
      {

      })
      Channels.on('statechange::ready',(current,old,container)=>
      {
          // Env.$html.classList.remove('skin--isWhite')
          // Env.$html.classList.remove('skin--isDark')
          // Env.$mainNav.classList.remove('is--active');
          // Env.$html.classList.remove('mainnav--isOpened')
      })
    }
}
export default UI;
